import { Box } from "@mui/material";

const ScannerOverlay = ({ visible }) => {
  if (!visible) return null;

  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        overflow: "hidden",
        pointerEvents: "none",
        zIndex: 3,
        borderRadius: 2,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          bottom: 0,
          width: "22%",
          background:
            "linear-gradient(90deg, rgba(124,58,237,0) 0%, rgba(124,58,237,0.28) 50%, rgba(124,58,237,0) 100%)",
          animation: "imageLayerScan 1.8s linear infinite",
          "@keyframes imageLayerScan": {
            "0%": { left: "-22%" },
            "100%": { left: "100%" },
          },
        }}
      />
    </Box>
  );
};

export default ScannerOverlay;
